import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const SortingModalCardHistoryMain = (props) => {
  const { isMobile } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import(
          '../MobileComponents/SortingModalCardHistoryMob'
        );
        setComponent(() => module.default);
      } else {
        const module = await import(
          '../WebComponents/SortingModalCardHistoryWeb'
        );
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? <LoadedComponent {...props} /> : <></>;
};

export default SortingModalCardHistoryMain;
